if (document.querySelector('#iframe-box')) {
  const formIFrame = document.querySelector('#iframe-box');
  const formIFrameDoc = (formIFrame.contentWindow || formIFrame.contentDocument);
  let loading = false;
  if (formIFrameDoc.document) {
    document.querySelector('.btn-to-submit a').addEventListener('click', (e) => {
      e.preventDefault();
      const inputElements = formIFrameDoc.document.querySelectorAll('input, select, textarea');
      const formData = {};
      let valid = false;
      inputElements.forEach((input) => {
        formData[input.id] = (input.type === 'checkbox') ? input.checked : input.value.trim();
        if (formData[input.id]) {
          valid = true;
        }
      });
      if (valid && !loading) {
        loading = true;
        const request = new XMLHttpRequest();
        request.open('POST', localData.siteURL, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.send(`action=sendCustomForm&id=${localData.id}&lang=${localData.lang}&inputs=${JSON.stringify(formData)}&nonce=${localData.nonce}`);
        request.onreadystatechange = function () {
          if (this.readyState === 4 && this.status === 200) {
            const response = JSON.parse(this.responseText);
            document.querySelector('.main').innerHTML = response.data.message;
            window.scrollTo({ top: formIFrame, behavior: 'smooth' });
          }
          loading = false;
        };
      }
    });
  }
}
